module.exports = __webpack_public_path__ + "img/house.c701076b.svg";